import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';
import type { Standort } from './../hooks/useStandort/entities/Standort';
import { useStandort } from './../hooks/useStandort/useStandort';
import { useManagerAuth } from './ManagerAuthContext';

export type StandortContextValue = {
  standort?: Standort;
  error?: string;
};

const StandortContext = createContext<StandortContextValue | undefined>(
  undefined,
);

export function StandortProvider({
  standortId,
  children,
}: {
  standortId?: string;
  children: ReactNode;
}) {
  const { standort: authStandort } = useManagerAuth();
  const value = useStandort(standortId ?? authStandort.id);

  return (
    <StandortContext.Provider value={value}>
      {children}
    </StandortContext.Provider>
  );
}

// oxlint-disable-next-line react/only-export-components
export function useStandortContext(): StandortContextValue {
  const context = useContext(StandortContext);

  if (context === undefined) {
    throw new Error(
      'useStandortContext must be used within a StandortProvider',
    );
  }

  return context;
}
